import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  isVisible = signal(true);

  constructor() {}
}
